import axios, { InternalAxiosRequestConfig } from 'axios';
import { BASE } from './constants';

const apiUser = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://users.bepass.app',
  headers: {
    'x-api-key': 'KW_sNizaSyDu_QNDPXcix4EAIXE9N9Ux_oH8g3q4dft3',
    'x-tenant-id': BASE.company.tenant,
    'x-api-flow': 'onboarding',
  }
});

apiUser.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers['x-tenant-id'] = BASE.company.tenant;
  return config;
});

export { apiUser };
